/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Input_InstructionsInputs */



/**
* | output |
* | --- |
* | "Accepted files: .jpg, .jpeg and .png" |
*
* @param {Plan_Input_InstructionsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_input_instructions = /** @type {((inputs?: Plan_Input_InstructionsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Input_InstructionsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Accepted files: .jpg, .jpeg and .png")
	return /** @type {LocalizedString} */ ("Fichier accepté : .jpg, .jpeg et .png")
});